<template>
  <div class="welcome-page">
    <!-- Cathy 卡通角色 -->
    <div class="character-container">
      <img :src="characterImage" alt="Cathy" class="character-img" />
    </div>

    <!-- 文本内容展示框（只展示，不可输入） -->
    <div class="text-box">
      <div class="welcome-input">
        {{ `你好,${displayName}! Cathy可以根据你的MBTI更准确地制定专属于你的职业规划,建议选择哦~` }}
      </div>
    </div>

    <!-- 底部按钮 -->
    <div class="action-buttons">
      <button class="btn-skip" @click="$emit('skip')">跳过,进入下一步</button>
      <button class="btn-test" @click="$emit('test')">MBTI测试</button>
      <button class="btn-select" @click="$emit('next')">选择MBTI →</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WelcomePage',
  props: {
    username: {
      type: String,
      default: ''
    }
  },
  emits: ['next', 'skip', 'test'],
  data() {
    return {
      characterImage: require('../assets/img/background.png')
    }
  },
  computed: {
    // 显示用名称，优先使用用户名，没有时回退到“飞猫”
    displayName() {
      return this.username || '飞猫'
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-base {
  padding: 0 24px;
  height: 36px;
  line-height: 36px;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.welcome-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100%;
  padding: 20px 150px 40px 150px;
  background: linear-gradient(to bottom, #f5f5f5 0%, #ffffff 100%);
  position: relative;
}

// Cathy 卡通角色
.character-container {
  margin-bottom: -10px;
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
}

.character-img {
  width: 428px;
  height: 302px;
  object-fit: contain;
}

// 文本内容框
.text-box {
  width: 100%;
  max-width: 800px;
  padding: 24px 32px;
  border-radius: 12px;
  margin-bottom: 40px;
  border: 2px solid transparent;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  background-clip: padding-box, border-box;
  background-origin: padding-box, border-box;
  background-image: linear-gradient(to right, #fff, #fff), linear-gradient(90deg, #62AFFF, #9C41FF);
}

.welcome-input {
  width: 100%;
  border: none;
  outline: none;
  background: transparent;
  font-size: 32px;
  line-height: 1.6;
  color: #333;
  text-align: center;
  white-space: pre-wrap;
  word-wrap: break-word;
  user-select: none; /* 禁止选中文本 */
  pointer-events: none; /* 禁止所有交互 */
}

// 底部按钮
.action-buttons {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 40px;
  width: 100%;
  max-width: 800px;
}

.btn-skip {
  @extend .btn-base;
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  color: #666;
  transition: all 0.2s ease;
  flex:1;

  &:hover {
    background: #f5f5f5;
    border-color: #d0d0d0;
  }
}

.btn-test {
  @extend .btn-base;
  background: #ffffff;
  border: 1px solid #7EB4EB;
  border-radius: 8px;
  color: #7EB4EB;
  transition: all 0.2s ease;
  flex:1;

  &:hover {
    background: #f0f7ff;
    border-color: #5a9de8;
  }
}

.btn-select {
  @extend .btn-base;
  background: linear-gradient(90deg, #7EB4EB 0%, #B16EF9 100%);
  color: #ffffff;
  flex:1;

  &:hover {
    opacity: 0.9;
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(177, 110, 249, 0.3);
  }
}

// 收缩状态下增加左右padding
.main-content.sidebar-collapsed .welcome-page {
  padding: 40px 260px;
}
</style>

